"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles, className) {
    return {
        root: styling_1.mergeStyles("app-view", styles.root, className),
        menuContainer: styling_1.mergeStyles("app-view-menu-container", styles.menuContainer),
        main: styling_1.mergeStyles("app-view-main", styles.main)
    };
});
exports.getClassNames = getClassNames;
